import styled from 'styled-components';
import { colors, toRgba, mixins } from '@/styles';

export const RowActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const RowStatusIndicator = styled.div`
  padding: 3px 7px;
  border-radius: 3px;
  border: 1px solid ${colors.secondary.lightGray3};
`;

export const DeleteRow = styled(RowStatusIndicator)`
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  background: ${colors.semantic.negative.dark};
  border-color: ${colors.semantic.negative.dark};
  color: ${colors.primary.white};
  cursor: pointer;
  border-radius: 3px;
  &:hover {
    background: ${colors.semantic.negative.primary};
    box-shadow: 0 0 5px 0px ${toRgba(colors.primary.black, 0.5)};
    /* text-decoration: underline; */
  }
`;

export const RevertRowChanges = styled(RowStatusIndicator)`
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  background: ${colors.secondary.lightGray2};
  border-color: ${colors.secondary.lightGray3};
  color: ${colors.primary.black};
  cursor: pointer;
  border-radius: 3px;
  &:hover {
    background: ${colors.secondary.lightGray3};
    box-shadow: 0 0 5px 0px ${toRgba(colors.primary.black, 0.5)};
    /* text-decoration: underline; */
  }
`;

export const AddedRow = styled(RowStatusIndicator)`
  color: ${colors.semantic.diff.added.indicator};
  border-color: ${colors.semantic.diff.added.indicator};
  background-color: ${colors.semantic.diff.added.background};
`;

export const ModifiedRow = styled(RowStatusIndicator)`
  color: ${colors.semantic.diff.modified.indicator};
  border-color: ${colors.semantic.diff.modified.indicator};
  background-color: ${colors.semantic.diff.modified.background};
`;

export const RemovedRow = styled(RowStatusIndicator)`
  color: ${colors.semantic.diff.removed.indicator};
  border-color: ${colors.semantic.diff.removed.indicator};
  background-color: ${colors.semantic.diff.removed.background};
`;
